'use client';

import dynamic from 'next/dynamic';
import type { FC, JSX } from 'react';
import type { ApiProductsCacheResponse } from '@ibe/api';
import type { MagnoliaNode, MagnoliaSite, PartialPageProps } from '@/types/cms/magnolia';
import type { ProductAdjusted } from '@/components/ProductsDatesPrices/DesktopContent';

const ProductsDatesPrices = dynamic(
  () => import('@/components/ProductsDatesPrices/ProductsDatesPrices')
);

const ProductsDatesPricesClientImporter: FC<{
  productPackages: Partial<ApiProductsCacheResponse>[];
  siteConfig?: MagnoliaSite;
  isVariant?: boolean;
  product?: ProductAdjusted;
  originalProduct?: ProductAdjusted;
  selectedPackage?: Partial<ApiProductsCacheResponse>;
  theme?: string;
  checkoutPageNode: MagnoliaNode;
  pageProps?: PartialPageProps;
}> = (props): JSX.Element => {
  return <ProductsDatesPrices {...props} />;
};

export default ProductsDatesPricesClientImporter;
